<div class="ddp-wrap-layout-popup" style="z-index: 160">
  <div class="ddp-box-popup ddp-box-popup-type1">
    <a href="javascript:" class="ddp-btn-close" (click)="closePopup()"></a>

    <div class="ddp-pop-title">{{ modal.name }}</div>

    <div class="ddp-pop-detail" *ngIf="modal.description">
      {{ modal.description }}
      <br />
      {{ modal.subDescription }}
    </div>

    <div class="ddp-ui-buttons">
      <a *ngIf="modal.isShowCancel" href="javascript:" class="ddp-btn-type-popup" (click)="closePopup()">
        {{ modal.btnCancel ? modal.btnCancel : ('msg.comm.btn.cancl' | translate) }}
      </a>

      <a *ngIf="!modal.btnName" href="javascript:" class="ddp-btn-type-popup ddp-bg-black" (click)="closePopup()">
        {{ 'msg.comm.btn.done' | translate }}
      </a>
      <a *ngIf="modal.btnName" href="javascript:" class="ddp-btn-type-popup ddp-bg-black" (click)="done()">
        {{ modal.btnName }}
      </a>
    </div>
  </div>
</div>
